/* global System */

export default {
  TeaserGrid: () =>
    System.import(/* webpackChunkName: "TeaserGrid" */ './index'),
}
